import Icon from '@ant-design/icons';

import { ReactComponent as RadioIcon } from './svgs/radio.svg';

const Radio = props => {
  return <Icon component={RadioIcon} {...props} />;
};

export default Radio;
